import styled from 'styled-components'
import { textAlign } from 'styled-system'

import theme from 'styles/theme'

export const ListWrapper = styled.ul`
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;

  ${theme.mediaQueries.small} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`

export const ListItem = styled.li`
  margin-top: ${theme.space[6]};
  width: 100%;

  &:first-child {
    margin-top: 0;
  }

  ${theme.mediaQueries.small} {
    width: calc(50% - (${theme.space[6]} / 2));

    &:nth-child(-n + 2) {
      margin-top: 0;
    }
  }

  ${theme.mediaQueries.medium} {
    width: calc((100% / 3) - (${theme.space[6]} * (2 / 3)));

    &:nth-child(-n + 3) {
      margin-top: 0;
    }

    &:nth-child(3n-1):last-child {
      margin-left: ${theme.space[6]};
      margin-right: auto;
    }
  }
`

export const Section = styled.section`
  ${textAlign}
`

export default {
  ListWrapper,
  Section,
}
